import idb from "@/plugins/indexdb.js";
import OtnRepo from "@/repositories/products/otn";

import otnDefaultForm from "./forms/otn";

export default {
  namespaced: true,
  state: {
    otn: otnDefaultForm
  },
  mutations: {
    SET_OTN(state, payload) {
      state.otn = Object.assign({}, state.otn, payload); // Merge
    },

    RESET_OTN(state) {
      state.otn = otnDefaultForm;
    }
  },
  actions: {
    /**
     * Get otn product by uuid
     *
     * @param {String} otn_uuid otn uuid
     */
    async get({ commit }, otn_uuid) {
      try {
        const { data } = await OtnRepo.get(otn_uuid);
        commit("SET_OTN", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new otn
    async createOtn(context, payload) {
      try {
        const { data } = await OtnRepo.createOtn(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Get otn product from IndexedDB by uuid
     *
     * @param {String} otn_uuid Otn uuid
     */
    async getFromLocal({ commit }, otn_uuid) {
      const otn = await idb.db.otn.get(otn_uuid);

      // If not found return null
      if (!otn) return null;

      commit("SET_OTN", otn);

      return otn;
    },

    // Reset otn
    resetProduct({ commit }) {
      commit("RESET_OTN");
    }
  }
};
